(function ($) {
    $(document).ready(function () {
        subMenuToggle();
        stickyElement();
    });

    // Untermenüs der Hauptnavigation per Klick auf den Eltern-Link auf-/zuklappen.
    // Konvention: Eltern-Einträge sind Links mit href="#". Echte Links navigieren normal.
    // Zustand = Klasse .is-open am <li> + aria-expanded am Link; Animation rein per CSS
    // (src/scss/_header.scss). Klick außerhalb oder Escape schließt alle.
    function subMenuToggle() {
        var $items = $(".main-nav .menu-item-has-children");
        if (!$items.length) return;

        var $links = $items
            .children("a")
            .attr({ "aria-haspopup": "true", "aria-expanded": "false" });

        function closeAll($except) {
            $items
                .not($except)
                .removeClass("is-open")
                .children("a")
                .attr("aria-expanded", "false");
        }

        $links.on("click", function (e) {
            var href = $(this).attr("href") || "#";
            if (href !== "#") return; // echter Link → navigieren

            e.preventDefault();
            var $li = $(this).parent();
            var open = !$li.hasClass("is-open");

            closeAll($li.parents(".menu-item-has-children").addBack()); // Geschwister zu, Vorfahren offen lassen
            $li.toggleClass("is-open", open);
            $(this).attr("aria-expanded", open ? "true" : "false");
        });

        $(document).on("click", function (e) {
            if (
                !$(e.target).closest(".main-nav .menu-item-has-children").length
            )
                closeAll();
        });

        $(document).on("keydown", function (e) {
            if (e.key === "Escape") closeAll();
        });
    }

    function stickyElement() {
        let h = $("header").outerHeight();

        $(".position-sticky").css("top", h);
    }
})(jQuery);
